import { useState } from 'react';
import PropTypes from 'prop-types';

import { brand } from '#/config/brand';

/**
 * 品牌 logo：僅在 logoUrl 有效且載入成功時渲染 `<img>`。
 * 空 URL／載入失敗 → null（公司名文字由呼叫端另行顯示）。
 */
const BrandLogo = ({ className, alt = brand.companyName }) => {
  const [hasError, setHasError] = useState(false);

  if (brand.logoUrl == null || hasError) {
    return null;
  }

  return (
    <img
      className={className}
      src={brand.logoUrl}
      alt={alt}
      onError={() => setHasError(true)}
    />
  );
};

BrandLogo.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string,
};

export default BrandLogo;
